// 号码前缀表单的草稿与换算，字段见 docs/03 3.6。prefix 是主键，只在新建时可填。
import type { Errors } from "@/app/useDraft";
import { validMcc, validMnc } from "@/app/form";
import type { EntityStatus, Input, NumberingPlan } from "@/app/master";

export interface PrefixDraft { prefix: string; country: string; mcc: string; mnc: string; operator_name: string; status: EntityStatus }

export function prefixDraft(row?: NumberingPlan): PrefixDraft {
  return row
    ? { prefix: row.prefix, country: row.country, mcc: row.mcc, mnc: row.mnc, operator_name: row.operator_name, status: row.status }
    : { prefix: "", country: "", mcc: "", mnc: "", operator_name: "", status: "active" };
}

export function prefixInput(d: PrefixDraft): { body?: Input<NumberingPlan>; errors: Errors<PrefixDraft> } {
  const errors: Errors<PrefixDraft> = {};
  if (!/^\d+$/.test(d.prefix)) errors.prefix = "国家码加号段的数字串。";
  if (!/^[A-Z]{2}$/.test(d.country)) errors.country = "两位大写国家代码，例如 ID。";
  if (!validMcc(d.mcc)) errors.mcc = "三位数字。";
  if (!validMnc(d.mnc)) errors.mnc = "两到三位数字，例如 10。";
  if (!d.operator_name.trim()) errors.operator_name = "填写运营商名称。";
  if (Object.keys(errors).length) return { errors };
  return { errors, body: { prefix: d.prefix, country: d.country, mcc: d.mcc, mnc: d.mnc, operator_name: d.operator_name.trim(), status: d.status } };
}
